import { APIClient } from "api/api_helper";
import { RETURNS_ACCOUNTABILITY_API } from "api/url_helper";
import { GetUserData, CurrentUser } from "common/service/CommonService";

const api = new APIClient();

export const returnsAccountabilityService = {
  insert: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    return api.create(RETURNS_ACCOUNTABILITY_API.RETURNS_ACCOUNTABILITY_API + "Insert", {
      ...payload,
      createdby: user.userid,
      status: "A",
    });
  },

  selectAll: (payload: any) => {
  return api.create(RETURNS_ACCOUNTABILITY_API.RETURNS_ACCOUNTABILITY_API + "SelectAll", {
    ...payload,
  });
},

  select: (payload: any) => {
  const user = GetUserData() as CurrentUser;
  return api.create(RETURNS_ACCOUNTABILITY_API.RETURNS_ACCOUNTABILITY_API + "Select", {
    ...payload,
  });
},

  update: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    return api.create(RETURNS_ACCOUNTABILITY_API.RETURNS_ACCOUNTABILITY_API + "Update", {
      ...payload,
      updatedby: user.userid,
    });
  },

  delete: (payload: any) => {
    const user = GetUserData() as CurrentUser;
    return api.create(RETURNS_ACCOUNTABILITY_API.RETURNS_ACCOUNTABILITY_API + "Delete", {
      ...payload,
      updatedby: user.userid,
    });
  },

  verifyPin: (payload: { verifypin: string, returnid: number , studyid: number , verifiedby: number }) => {
        return api.create(RETURNS_ACCOUNTABILITY_API.RETURNS_ACCOUNTABILITY_API + "Verify", payload);
  },

  dropdown: (payload: any) => {
      return api.create(RETURNS_ACCOUNTABILITY_API.RETURNS_ACCOUNTABILITY_API + "Dropdown", {
          ...payload  
      });
  },

  subjectDropdown: (payload: any) => {
      return api.create(RETURNS_ACCOUNTABILITY_API.RETURNS_ACCOUNTABILITY_API + "SubjectDropdown", {
          ...payload  
      });
  },
      
};